var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.itemid
    ? _c(
        "section",
        { staticClass: "header-region", class: _vm.headerClasses },
        [
          _c(
            "div",
            {
              staticClass: "header-content-position",
              class: { "content-gradient": _vm.hasImage },
            },
            [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "header-content" },
                      [
                        _c("div", { staticClass: "header-leadline" }, [
                          _c("h3", [_vm._v(_vm._s(_vm.headerLeadline))]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-title" }, [
                          _c("h1", [_vm._v(_vm._s(_vm.title))]),
                        ]),
                        _vm._v(" "),
                        _vm.item
                          ? [
                              _vm.headerDescription
                                ? _c("div", {
                                    staticClass: "header-description",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.headerDescription),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.hasImage
            ? _c("AImage", {
                attrs: {
                  img: _vm.headerImage,
                  responsive: "",
                  preset: "banner",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }